import React, { useState, useEffect } from "react";

import styled, { css } from "styled-components";


export const XBEappearer = ({
  on = false,
  style,
  index,
  className,
  children,
  shown = true,
  size
}) => {

  return (

    <CssAppearerEl0
    shown={shown}
    className={className}
    >
      <CssAppearerEl
        style={style}
        appear={on}
        shown={shown}
      >

          {children}
      </CssAppearerEl>
      </CssAppearerEl0>

  );
};


const CssAppearerEl = styled.div`
  min-width: 360px;
  @media(max-width: 768px) {
    min-width: auto;
  }
  transition: all 300ms ease-in-out;
  opacity: 1;
`;



const CssAppearerEl0 = styled.div`

  /* initial state */
  flex-basis: 30%;
  max-width: 38%;
  flex-grow:1;
  transition: all 300ms ease-in-out;
  opacity: 1;
  transform: translate(0, 0px);

  /* hidden on web  */
  ${({ shown }) => !shown && css`

      transform: scale(0.9) translate(0, 0px);
      opacity: 0;
      width: 0px;
      flex-grow:0;
      flex-basis: 0%;
      min-width: 0px;
      max-width: 0px !important;
      margin: 0;
      padding: 0;
      overflow: hidden;
      margin: 0px;
      padding: 0px;
    `}

    /*  hidden on mobile  */
    @media(max-width: 768px) {
      width: 100%;
      flex-basis: 100%;
      max-width: 100%;
      ${({ shown }) => !shown && css`
          width: 0px;
          height: 0px;
          flex-grow:0;
          opacity: 0;
          width: 0px;
          max-width: 0px;
          flex-basis: 0%;
          margin: 0;
          padding: 0;
          overflow: hidden;
          margin: 0px;
          padding: 0px;
      `}
  }
`;
